import {createNode} from "./common/ui";

(function () {
	function init() {
		function initUi() {
			const shopCountriesRadios = document.querySelectorAll('[name=countries__country]');
			const shopListContainer = document.querySelector('.sys__shops-list');
			const categoryId = document.querySelector('[data-category-id]').getAttribute('data-category-id');

			function shopShopNodeFrom(shop) {
				const categoryShop = createNode('li', 'shops__category-shop');
				const categoryShopCard = shop.hasDetailedPage
					? createNode(
						'a',
						'shops__category-shop-card',
						{
							href: `/shops/${shop.id}.html`,
							title: `${shop.name}`,
						})
					: createNode(
						'a',
						'shops__category-shop-card',
						{
							href: `${shop.link}`,
							title: `${shop.name}`,
							target: '_blank',
						});

				const cardLogo = createNode('div', 'shops__category-shop-logo');
				if (!!shop.vpn) {
					const cardLogoBadge = createNode(
						'span',
						'shops__category-shop-logo-badge',
						{
							title: 'Для доступа в магазин понадобится VPN',
							innerText: 'VPN',
						})
					cardLogo.appendChild(cardLogoBadge);
				}
				const cardLogoPicture = createNode('picture');
				const cardLogoSource = createNode(
					'source',
					undefined,
					{
						srcset: `/images/webp/shops/${shop.logoWebp}, /images/webp/shops/${shop.logoWebp2x} 2x, /images/webp/shops/${shop.logoWebp3x} 3x`,
						type: 'image/webp'
					}
				);
				const cardLogoImg = createNode(
					'img',
					undefined,
					{
						src: `/images/shops/${shop.logo}`,
						srcset: `/images/shops/${shop.logo}, /images/shops/${shop.logo2x} 2x, /images/shops/${shop.logo3x} 3x`,
						alt: shop.name,
						loading: 'lazy'
					}
				)
				cardLogoPicture.appendChild(cardLogoSource);
				cardLogoPicture.appendChild(cardLogoImg);
				cardLogo.appendChild(cardLogoPicture);

				const shopName = createNode('span', 'shops__category-shops-shop-name', {innerText: shop.name});

				const shopLink = createNode(
					'span',
					'button button--primary button--accent shops__category-shops-shop-link',
					{
						innerText: 'В магазин',
					});

				categoryShopCard.appendChild(cardLogo);
				categoryShopCard.appendChild(shopName);
				categoryShopCard.appendChild(shopLink);
				categoryShop.appendChild(categoryShopCard);

				return categoryShop;
			}

			function replaceShopsWith(source) {
				shopListContainer.innerHTML = '';
				const categoryContainer = createNode('div', 'shops__category-shops-category');
				const categoryShopsList = createNode('ul', 'shops__category-shops-list');

				for (let shop of source) {
					categoryShopsList.appendChild(shopShopNodeFrom(shop));
				}

				categoryContainer.appendChild(categoryShopsList);
				shopListContainer.appendChild(categoryContainer);
			}

			return {
				onCountryClick: function (loadShopsHandler) {
					for (let countryRadio of shopCountriesRadios) {
						countryRadio.addEventListener('change', function () {
							loadShopsHandler(countryRadio.value)
								.then((data) => {
									replaceShopsWith(data);
								})
						});
					}
				},
				categoryId: categoryId
			};
		}

		function initApi() {
			const random = Math.floor(Math.random() * 10000000000000000);
			return {
				fetchShops: function (countryIsoCode, categoryId) {
					return new Promise((resolve, reject) => {
						fetch(`/get/${countryIsoCode}/shops__${categoryId}.json?${random}`)
							.then(response => {
								response.json().then((data) => {
									resolve(data)
								}).catch(reject);
							})
							.catch(reject);
					});
				}
			};
		}

		function initBehaviour(ui, api) {
			const categoryId = ui.categoryId;
			const loadShopsHandler = (countryIsoCode) => api.fetchShops(countryIsoCode, categoryId);

			ui.onCountryClick(loadShopsHandler);
		}

		const ui = initUi();
		const api = initApi();
		initBehaviour(ui, api);
	}

	document.addEventListener('DOMContentLoaded', function () {
		init();
	});
})();
